namespace Nobox.NoBoxCRM {
    export interface RoomIdRequest {
        TemplateId?: string;
        ResultId?: string;
        IdExt?: string;
    }
}
